import SyAsynSelect from "./sy-asyn-select";

export default SyAsynSelect